module.exports = __webpack_public_path__ + "static/media/arrow-forward.83bc0dda.svg";